// Generated by ReScript, PLEASE EDIT WITH CARE


function t(headingColorOpt, colorOpt, iconColorOpt, param) {
  var headingColor = headingColorOpt !== undefined ? headingColorOpt : ({
        NAME: "hex",
        VAL: "1E1E1E"
      });
  var color = colorOpt !== undefined ? colorOpt : ({
        NAME: "hex",
        VAL: "4B4B4B"
      });
  var iconColor = iconColorOpt !== undefined ? iconColorOpt : ({
        NAME: "hex",
        VAL: "48096C"
      });
  return {
          headingColor: headingColor,
          color: color,
          iconColor: iconColor
        };
}

export {
  t ,
}
/* No side effect */
